import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Checkbox } from '../../../components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Users2, Loader2 } from 'lucide-react';

export const BulkAddToTeamDialog = ({
  open, onOpenChange, selectedCount, teams, selectedTeam, setSelectedTeam,
  overrideWarnings, setOverrideWarnings, loading, onSubmit
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="bulk-add-to-team-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Users2 className="h-5 w-5 text-blue-600" />Bulk Add Players to Team</DialogTitle>
        <DialogDescription>Add {selectedCount} selected player(s) to a team</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-sm text-blue-700"><strong>{selectedCount}</strong> player(s) selected</p>
        </div>
        <div className="space-y-2">
          <Label>Select Team</Label>
          <Select value={selectedTeam} onValueChange={setSelectedTeam}>
            <SelectTrigger data-testid="bulk-team-select"><SelectValue placeholder="Choose a team..." /></SelectTrigger>
            <SelectContent>
              {teams.map(team => (<SelectItem key={team.id} value={team.id}>{team.name}{team.age_category ? ` (${team.age_category.toUpperCase()})` : ''} - {team.player_count || 0} players</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center space-x-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <Checkbox id="bulk-override-warnings" checked={overrideWarnings} onCheckedChange={setOverrideWarnings} data-testid="bulk-override-checkbox" />
          <Label htmlFor="bulk-override-warnings" className="text-sm text-amber-700 cursor-pointer">Override eligibility warnings (add players even if age/category doesn't match)</Label>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>Cancel</Button>
        <Button onClick={onSubmit} disabled={loading || !selectedTeam} data-testid="bulk-add-to-team-submit">
          {loading ? (<><Loader2 className="h-4 w-4 mr-2 animate-spin" />Adding...</>) : (<><Users2 className="h-4 w-4 mr-2" />Add {selectedCount} to Team</>)}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
